export const getTotalContributions = (holdingPeriod: number, annualContribution: number) =>
  annualContribution * holdingPeriod;
